module.exports = __webpack_public_path__ + "static/media/bg-banner-news.898aa95c.jpg";